<template>
  <div class="teleInfos">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="placeName" :placeholder="$t('lang.lab_placeName')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="topics">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="addTel()">{{$t('lang.lab_addPlace')}}</el-button>
      <el-button type="primary" slot="header" @click="jump">{{$t('lang.btn_backpage')}}</el-button>
      <el-table :data="tableData" class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="teleInfosListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- 车位名称 -->
        <el-table-column prop="placeName" :label="$t('lang.lab_placeName')"></el-table-column>
        <el-table-column prop="endDate" :label="$t('lang.lab_controlPeriod')" :formatter="parseDateFull">
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right"
          :width="require('@/config/enum').opr_width3">
          <template slot-scope="scope">
            <el-button @click="changeTel(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="delTele(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 添加弹框 -->
    <el-dialog :title="titleShow" :visible.sync="diaIsShow" :close-on-click-modal="false" center top="130px"
      width="600px" @closed="handleDialogClosed">
      <!-- 表单验证 -->
      <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon">
        <!-- 名称 -->
        <el-form-item :label="$t('lang.lab_placeName')" prop="placeName">
          <el-input v-model="form.placeName" :placeholder="$t('lang.lab_placeName')" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_placeName')" prop="placeName">
          <el-input v-model="form.placeName" :placeholder="$t('lang.lab_placeName')" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_controlPeriod')" prop="endDate">
          <el-date-picker class="select" v-model="form.endDate" type="date" value-format="timestamp"
            :placeholder="$t('lang.lab_controlPeriod')"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="save('form')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:teleInfo
   *@Description:电话信息
   *@author:李斌
   *@Copyright:格众科技
   *@date:2020-03-13
   */
  import { mapGetters } from 'vuex'
  
  export default {
    data() {
      return {
        parkId: '',
        isDisabled: true, // 按钮置灰
        saveData: '', // 存储json字符串
        name: '', // 名称
        content: '', // 电话
        serviceTime: '', // 服务时间
        editId: '', // 接收参数
        titleShow: '', // 弹框标题
        diaIsShow: false, // 弹框是否显示
        pageNum: 1, // 页数
        pageSize: 10, // 每页数量
        pageCount: 0, // 总页数
        tableData: [], // 表单数据
        multipleSelection: [], // 多选框
        type: '', // 判断checkbox的值
        teleInfosListcheckbox: require('@/config/enum').teleInfosListcheckbox, // 是否隐藏复选框
        form: {
          placeName: '',
          endDate: ''
        },
        placeName: '',
        rules: {
          placeName: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input'),
            trigger: 'blur'
          }],
          endDate: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input'),
            trigger: 'blur'
          }]
        },
      }
    },
    // 初始化
    created() {
      this.parkId = this.$route.query.id
      this.topics()
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    // 监听小区编号
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.topics()
      },
      form: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      // 用户名只能输入数字
      keyBA() {
        // 仅保留数字和"."
        this.form.totalNum = this.form.totalNum.replace(/[^\d]/g, '')
        // 首位是0的话去掉
        if (this.form.totalNum.indexOf('.') < 0 && this.form.totalNum != '') {
          this.form.totalNum = parseFloat(this.form.totalNum)
        }
      },
      parseDateFull(row, column, cellValue, index) {
        var x = new Date(cellValue)
        var z = {
          y: x.getFullYear(),
          M: x.getMonth() + 1,
          d: x.getDate(),
          h: x.getHours(),
          m: x.getMinutes(),
          s: x.getSeconds(),
        }
        if (z.M < 10) {
          z.M = '0' + z.M
        }
        if (z.d < 10) {
          z.d = '0' + z.d
        }
        if (z.h < 10) {
          z.h = '0' + z.h
        }
        if (z.m < 10) {
          z.m = '0' + z.m
        }
        return z.y + '-' + z.M + '-' + z.d
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      topics() {
        let loading = this.$loading()
        this.$get(
          `/carPlace?parkId=${this.parkId}&placeName=${this.placeName}&pageNo=${this.pageNum}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 添加电话
      addTel() {
        this.editId = ''
        this.titleShow = this.$i18n.t('lang.lab_addPlace')
        this.form.placeName = ''
        this.form.endDate = ''
        this.diaIsShow = true
      },
      // 修改电话信息
      changeTel(row) {
        this.editId = row.id
        this.titleShow = this.$i18n.t('lang.lab_changePark')
        this.form.placeName = row.placeName
        this.form.endDate = row.endDate
        this.saveData = JSON.stringify(this.form)
        this.diaIsShow = true
      },
      // 删除
      delTele(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            this.$delete(`carPlace/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 保存
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.editId === '') {
              let d = new Date(this.form.endDate)
              let params = {
                parkId: this.parkId,
                endTime: d.getTime(d),
                placeName: this.form.placeName
              }
              if (this.parkId === 0) {
                this.$message.error(this.$i18n.t('lang.lab_please_Select'))
                return
              }
              let loading = this.$loading()
              console.log(params)
              this.$post(`/carPlace/`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.topics()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              let loading = this.$loading()
              let d = new Date(this.form.endDate)
              let params = {
                parkId: this.parkId,
                endTime: d.getTime(d),
                placeName: this.form.placeName
              }
              this.$patch(`/carPlace/${this.editId}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.topics()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
              console.log(params.type)
            }
          }
        })
      },
      clear() {
        this.$refs.form.resetFields()
        this.form.parkName = ''
        this.form.totalNum = ''
        this.form.isRepeat = '1'
      },
      jump() {
        this.$router.push({
          name: 'carPackList'
        })
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.clear()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.topics()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.topics()
      }
    }
  }
</script>

<style lang="scss">
</style>